
import { cdn } from "core/cdn";
import styles from "./Alert.module.scss"
import {AlertMessage} from "containers/Survey/types"

const Alert = ({type, description, style, img}: AlertMessage) => {

    const imgsrcIcon = type==="info"? cdn("images/attention_picto.svg") : null 
    // Right now only the info image icon is rendered, in the future we will add other icons depnding of needs

    return (
        <div className={styles.alert_box} style={style}>
            {imgsrcIcon && <img className={styles.alert__icon} src={img ? img : imgsrcIcon} alt="alert icone" />}
            <p className={styles.alert__description}> {description} </p>
        </div>
    )

}

export default Alert;